import { useCallback } from 'react';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

/**
 * Returns a helper for a table column's `fixed` prop that pins the column only on md+ screens.
 * On phones pinned columns eat most of the width and leave the rest of the table a thin
 * scroll strip, so there every column scrolls normally.
 */
export function useResponsivePinnedColumn() {
  const screens = useBreakpoint();
  // Breakpoints are empty on the first render; keep the column pinned until md is known to be false.
  const canPin = screens.md !== false;
  return useCallback(<Side extends 'left' | 'right'>(side: Side): Side | undefined => (canPin ? side : undefined), [canPin]);
}
